import { ArdoqId, APIEntityType } from '@ardoq/api-types';
import { readRawValue } from '../../scopeData/utils/readRawValue';
import { EnhancedScopeDataWithBranchName } from '../../scopeData/enhanceScopeData';
import {
  withEntitiesListPopover,
  withWorkspacePopover,
} from '../../DiffMergeTablePopover/utils';
import { EntityName, FlexWrapper } from './atoms';
import { ReferenceLinePreview } from '@ardoq/icons';
import { DecoratorWrapper } from '@ardoq/decorators';
import { EnhancedScopeData } from '@ardoq/data-model';
import { isEnhancedScopeDataWithBranchName } from './utils';

const ReferenceTypeRepresentation = ({
  entityId,
  parentEntityId,
  enhancedScopeData,
  isCommaSeparated,
  hasLabelEllipsis,
  hideDefaultPopover,
  shouldHaveWrapper,
}: {
  entityId: number;
  parentEntityId: ArdoqId;
  enhancedScopeData: EnhancedScopeDataWithBranchName | EnhancedScopeData;
  isCommaSeparated?: boolean;
  hasLabelEllipsis?: boolean;
  hideDefaultPopover?: boolean;
  shouldHaveWrapper?: boolean;
}) => {
  // If it has ellipsis then skip the arrow representation and display
  // only name with ellipsis
  if (hasLabelEllipsis) {
    return (
      <FlexWrapper>
        <EntityName
          entityType={APIEntityType.REFERENCE_TYPE}
          entityId={entityId}
          parentEntityId={parentEntityId}
          enhancedScopeData={enhancedScopeData}
          hasLabelEllipsis
          popoverAttributes={
            hideDefaultPopover ||
            !isEnhancedScopeDataWithBranchName(enhancedScopeData)
              ? {}
              : withEntitiesListPopover({
                  branch: enhancedScopeData.branchName,
                  entityIds: [entityId],
                  entityType: APIEntityType.REFERENCE_TYPE,
                  parentEntityId,
                })
          }
        />
      </FlexWrapper>
    );
  }

  const [line, color, lineBeginning, lineEnding] = [
    'line',
    'color',
    'lineBeginning',
    'lineEnding',
  ].map(fieldName =>
    readRawValue(
      APIEntityType.REFERENCE_TYPE,
      entityId,
      fieldName,
      enhancedScopeData,
      parentEntityId
    )
  );

  return (
    <>
      <DecoratorWrapper
        style={{ display: shouldHaveWrapper ? 'inline-flex' : 'flex' }}
      >
        <EntityName
          popoverAttributes={
            hideDefaultPopover ||
            !isEnhancedScopeDataWithBranchName(enhancedScopeData)
              ? {}
              : withWorkspacePopover({
                  branch: enhancedScopeData.branchName,
                  entityId,
                  parentEntityId,
                  entityType: APIEntityType.REFERENCE_TYPE,
                })
          }
          entityType={APIEntityType.REFERENCE_TYPE}
          entityId={entityId}
          parentEntityId={parentEntityId}
          enhancedScopeData={enhancedScopeData}
        />
        <ReferenceLinePreview
          lineBeginning={lineBeginning}
          lineEnding={lineEnding}
          width={70}
          color={color}
          line={line}
        />
      </DecoratorWrapper>
      {isCommaSeparated && <>, &nbsp;</>}
    </>
  );
};

export { ReferenceTypeRepresentation };
